"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FACE_KEYS = exports.ON = exports.BACK = exports.FRONT = void 0;
exports.FRONT = 'front';
exports.BACK = 'back';
exports.ON = 'on';
exports.FACE_KEYS = ['a', 'b', 'c'];
//# sourceMappingURL=constants.js.map